import React, { useState } from "react";
import { Row, Col, Button, Input, Form, message, Radio } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { postAuthMethod } from "../../services/HttpServices";
import WhatsAppConnectImg from "../../assets/svg/whats-app-connect.png";

const WhatsAppRegistrationForm = ({ connectionData, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [hasPin, setHasPin] = useState(false);
  const [pin, setPin] = useState("");

  const failedPhones = connectionData?.phoneNumbers?.filter(p => p.cloudApiRegistrationStatus === 'FAILED') || [];
  
  const handleVerify = () => {
    let pinToSubmit = pin;

    if (hasPin) {
      if (!pin || pin.trim().length !== 6) {
        message.error("Please enter a valid 6-digit PIN");
        return;
      }
      pinToSubmit = pin.trim();
    } else {
      pinToSubmit = "123456"; // Default PIN
    }

    setLoading(true);
    postAuthMethod("/api/whatsapp/accounts/register-phone", { pin: pinToSubmit })
      .then((response) => {
        if (response.data && response.data.success) {
          message.success("WhatsApp number successfully registered!");
          if (onSuccess) onSuccess();
        } else {
          message.error("Failed to register number. Please try again.");
        }
      })
      .catch((err) => {
        console.error("Registration error:", err);
        message.error(
          err.response?.data?.error || "Failed to register number. Please try again."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Row
      align="middle"
      className="tw-min-h-[calc(100vh-64px)] tw-px-6 tw-py-10 !tw-m-0"
      gutter={[32, 40]}
    >
      <Col xs={24} md={12}>
        <h1 className="tw-text-[42px] tw-font-semibold tw-leading-tight tw-text-text-primary tw-mb-4">
          WhatsApp Phone
          <br />
          Registration
        </h1>
        <div className="tw-mb-10">
          <p className="tw-text-sub-text tw-text-xl tw-font-normal tw-mb-2">
            Almost done! We need to register your phone number with Meta to start sending messages.
          </p>
          {failedPhones.length > 0 && (
            <div className="tw-mt-4 tw-p-4 tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-md">
              <p className="tw-text-red-600 tw-font-medium tw-mb-2">Registration failed for:</p>
              <ul className="tw-list-disc tw-pl-5 tw-m-0">
                {failedPhones.map(phone => (
                  <li key={phone.phoneNumberId} className="tw-text-red-500 tw-text-sm">
                    {phone.displayPhoneNumber}: {phone.lastErrorMessage || "Unknown error"}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="tw-bg-[#f9f9f9] tw-p-6 tw-rounded-[10px] tw-border tw-border-solid tw-border-gray-200 tw-max-w-md tw-mb-8">
          <Form layout="vertical" onFinish={handleVerify}>
            <Form.Item 
              label={<span className="tw-font-medium tw-text-base">Do you have a 2-Step Verification PIN set for this number?</span>}
              required
            >
              <Radio.Group 
                onChange={(e) => setHasPin(e.target.value)} 
                value={hasPin}
                className="tw-flex tw-flex-col tw-gap-3 tw-mt-2"
              >
                <Radio value={false} className="tw-text-base">No, I do not have a PIN</Radio>
                <Radio value={true} className="tw-text-base">Yes, I have a PIN</Radio>
              </Radio.Group>
            </Form.Item>

            {hasPin && (
              <Form.Item 
                label={<span className="tw-font-medium">Enter your 6-Digit PIN</span>}
                required
                className="tw-mt-4 tw-mb-0"
              >
                <Input.Password
                  prefix={<LockOutlined className="tw-text-gray-400" />}
                  placeholder="••••••"
                  maxLength={6}
                  size="large"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                  className="!tw-rounded-md"
                />
              </Form.Item>
            )}
            
            <div className="tw-flex tw-gap-3 tw-mt-8">
              <Button 
                onClick={onCancel}
                size="large"
                className="tw-flex-1 !tw-rounded-lg"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="tw-flex-1 !tw-bg-[#25D366] !tw-text-white !tw-font-semibold !tw-rounded-lg !tw-border-none"
                size="large"
              >
                Register
              </Button>
            </div>
          </Form>
        </div>
      </Col>

      <Col
        xs={24}
        md={12}
        className="tw-flex tw-justify-center tw-items-center"
      >
        <img
          src={WhatsAppConnectImg}
          alt="WhatsApp Business Connect"
          className="tw-w-full tw-max-w-xl tw-object-contain tw-drop-shadow-2xl tw-opacity-80"
        />
      </Col>
    </Row>
  );
};

export default WhatsAppRegistrationForm;
